import { render, staticRenderFns } from "./ProductFilterTrim.vue?vue&type=template&id=e082745c&"
import script from "./ProductFilterTrim.vue?vue&type=script&lang=js&"
export * from "./ProductFilterTrim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports